import React from 'react'
import SiteFooterAccess from '../../SiteFooterAccess/SiteFooterAccess'
import SiteHeaderAccess from '../../SiteHeaderAccess/SiteHeaderAccess'
import { useCssVarsAccess } from '../../hooks/useCssVarsAccess'


const PageAccessWrapper = ({
    children
}) => (
    <div style={useCssVarsAccess()}>
        <SiteHeaderAccess/>

        <main id="maincontent" className="theme-access" role="main">
            <div className="grid-site-wrapper">
                {children}
            </div>
        </main>

        <SiteFooterAccess />
    </div>
)

export default PageAccessWrapper